module.exports = __webpack_public_path__ + "static/media/sound-icon.5647be8f.svg";